import React, { useEffect, useState, useRef } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import NewsMain from "./NewsMain";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getAllNews } from "../../services/newsServices";

const News = () => {
  useEffect(() => {
    document.title = "News | Society of Aquaculture Professionals";
  }, []);

  const [pageIndex, setPageIndex] = useState(0);

  // Create ref for the main container
  const mainContainerRef = useRef(null);

  const {
    data,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    isLoading,
    isError,
  } = useInfiniteQuery({
    queryKey: ["news"],
    queryFn: ({ pageParam = "" }) =>
      getAllNews({ lastId: pageParam, status: "approved" }),
    getNextPageParam: (lastPage) =>
      lastPage?.data?.hasMore ? lastPage.data.nextCursor : undefined,
    initialPageParam: "",
  });

  // Enhanced scroll to top function
  const scrollToTop = () => {
    if (mainContainerRef.current) {
      // Method 1: Using scrollIntoView (most reliable)
      mainContainerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    } else {
      // Fallback: Use window scroll
      try {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } catch (error) {
        window.scrollTo(0, 0);
      }
    }
  };

  const handleNext = async () => {
    if (pageIndex + 1 < (data?.pages.length || 0)) {
      setPageIndex((prev) => prev + 1);
      setTimeout(scrollToTop, 50);
    } else if (hasNextPage) {
      await fetchNextPage();
      setPageIndex((prev) => prev + 1);
      setTimeout(scrollToTop, 50);
    }
  };

  const handlePrev = () => {
    if (pageIndex > 0) {
      setPageIndex((prev) => prev - 1);
      setTimeout(scrollToTop, 50);
    }
  };

  const newsList = data?.pages?.[pageIndex]?.data?.items || [];

  return (
    <div ref={mainContainerRef}>
      <Header />
      <NewsMain
        news={newsList}
        handleNext={handleNext}
        handlePrev={handlePrev}
        hasMore={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        pageIndex={pageIndex}
        isLoading={isLoading}
        isError={isError}
        totalFetchedPages={data?.pages.length || 0}
      />
      <Footer />
    </div>
  );
};

export default News;
